import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchClaimStatus = createProvider(api.fetchClaimStatus)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch claim status aborted');
    } else {
      console.error('Fetch claim status was failed:', error);
    }
    throw error;
  });
